import { render, staticRenderFns } from "./AdministrationProductActiveSwitch.vue?vue&type=template&id=472459f8&scoped=true&"
import script from "./AdministrationProductActiveSwitch.vue?vue&type=script&lang=js&"
export * from "./AdministrationProductActiveSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472459f8",
  null
  
)

export default component.exports